module.exports = __webpack_public_path__ + "static/media/logoblanco.7ad9cd06.png";